import {
  getLeoUuid,
  LeoUUID,
  getInt32,
  getString,
  getLeoTimestamp,
  LeoTimestamp,
  getObject,
} from "@surya-digital/leo-ts-types";
import { EmailStatus } from "../types/emailStatus";

export interface EmailRecipientDTO {
  id: string;
  respondentId: number;
  email: string;
  addedOn: string;
  status: EmailStatus.EmailStatusDTO;
}

export class EmailRecipient {
  readonly isEmailRecipientEmailRecipient: boolean = true;

  readonly id: LeoUUID;
  readonly respondentId: number;
  readonly email: string;
  readonly addedOn: LeoTimestamp;
  readonly status: EmailStatus.EmailStatus;


  constructor(
  id: LeoUUID, 
  respondentId: number, 
  email: string, 
  addedOn: LeoTimestamp, 
  status: EmailStatus.EmailStatus
  ) {
    this.id = id;
    this.respondentId = respondentId;
    EmailRecipient.validateEmail(email);
    this.email = email;
    this.addedOn = addedOn;
    this.status = status;
  }

  static fromDTO(dto: EmailRecipientDTO): EmailRecipient {
    const id = getLeoUuid(dto, "id", InvalidEmailRecipientIdError);
    const respondentId = getInt32(dto, "respondentId", InvalidEmailRecipientRespondentIdError);
    const email = getString(dto, "email", InvalidEmailRecipientEmailError);
    const addedOn = getLeoTimestamp(dto, "addedOn", InvalidEmailRecipientAddedOnError);
    const status = EmailStatus.fromDTO(getObject(dto, "status", InvalidEmailRecipientStatusError));
    return new EmailRecipient(
      id,
      respondentId,
      email,
      addedOn,
      status
    );
  }

  toDTO(): EmailRecipientDTO {
    const dto: EmailRecipientDTO = {
        id: this.id.toDTO(),
        respondentId: this.respondentId,
        email: this.email,
        addedOn: this.addedOn.toDTO(),
        status: EmailStatus.toDTO(this.status)
    };
    return dto;
  }
  private static validateEmail = (email: string): void => {
    if(email.trim().length === 0) {
      throw new InvalidEmailRecipientEmailNonEmptyError(
        `Attribute email cannot be an empty string.`
      );
    }
  }
  
}

EmailRecipient.prototype.toString = function toString(): string {
  return `EmailRecipient(id='${this.id}',respondentId='${this.respondentId}',email='${this.email}',addedOn='${this.addedOn}',status='${this.status}')`;
};

export class InvalidEmailRecipientError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidEmailRecipientError";
  }
}
export class InvalidEmailRecipientIdError extends InvalidEmailRecipientError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidEmailRecipientIdError";
  }
}

export class InvalidEmailRecipientRespondentIdError extends InvalidEmailRecipientError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidEmailRecipientRespondentIdError";
  }
}

export class InvalidEmailRecipientEmailError extends InvalidEmailRecipientError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidEmailRecipientEmailError";
  }
}

export class InvalidEmailRecipientEmailNonEmptyError extends InvalidEmailRecipientEmailError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidEmailRecipientEmailNonEmptyError";
  }
}

export class InvalidEmailRecipientAddedOnError extends InvalidEmailRecipientError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidEmailRecipientAddedOnError";
  }
}

export class InvalidEmailRecipientStatusError extends InvalidEmailRecipientError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidEmailRecipientStatusError";
  }
}
